import moment from 'moment';
moment.locale('ja');
export const dateformatMixin = {
    methods: {
        getDateFormat(date) {
            if(date == null || date == '' || !date.trim()){
                return "";
            }
            let _date = new Date(date);
            return  moment(date).format('YYYY/MM/DD');
        },
        // 曜日付き
        getDateWithWeekText(date) {
            if(date == null || date == '' || !date.trim()){
                return "";
            }
            let _date = new Date(date);
            return  moment(date).format('YYYY/MM/DD(ddd)');
        },
        // 曜日、時刻付き (本日の場合は時刻のみ)
        getDateWithWeekTimeText(date) {
            if(date == null || date == '' || !date.trim()){
                return '';
            }

            let res = "";
            if (moment().format('YYYY/MM/DD') == moment(date).format('YYYY/MM/DD')) {
                // 今日の場合は時刻を表示
                res = moment(date).format('HH:mm');
            } else {
                // 別日の場合は年月日(曜日)時刻
                res = moment(date).format('YYYY/MM/DD(ddd) HH:mm');
            }
            return res;
        },
        // 曜日、時刻無し（本日の場合は時刻のみ）
        getDateOrTimeText(date) {
            if(date == null || date == '' || !date.trim()){
                return '';
            }

            let res = "";
            if (moment().format('YYYY/MM/DD') == moment(date).format('YYYY/MM/DD')) {
                // 今日の場合は時刻を表示
                res = this.getDateWithWeekTimeText(date);
            } else {
                // 別日の場合は年月日(曜日)
                res = this.getDateWithWeekText(date);
            }
            return res;
        },
        // 曜日時刻付き 
        weekTimeFormat(date) {
            if(date == null || date == '' || !date.trim()){
                return '';
            }
            return moment(date).format('YYYY/MM/DD(ddd) HH:mm');
        },
    }
} 
